export const navItems = [
    {
        title: 'Home',
        link: '/'
    },
    {
        title: 'How it works',
        anchor: 'how_it_works'
    },
    {
        title: 'NFTs',
        anchor: 'nft_shop'
    },
    {
        title: 'Community',
        anchor: 'community'
    }
]
